export default __webpack_public_path__ + "static/ChangeTheWorld-fee6b253b28f0e0b472e8d1ba3064c3e.jpg";